import api from './api';

/**
 * Steamship-line SCACs for the Pro Detail "SCAC" dropdown (order.scac).
 *
 * Sourced from `/cms-lookups/scacs` (cms.scacprofiles, type='ssline', active),
 * `value` = SCAC code, `label` = "SCAC — SS Line Name". The list is small and
 * effectively static within a session, so it's cached in module scope to avoid
 * duplicate fetches across pro-detail mounts (same pattern as rails.service).
 */

export interface ScacOption {
  value: string;
  label: string;
}

let scacsCache: Promise<ScacOption[]> | null = null;

export async function getScacs(): Promise<ScacOption[]> {
  if (!scacsCache) {
    scacsCache = api
      .get<ScacOption[]>('/cms-lookups/scacs')
      .then((r) => r.data)
      .catch((err) => {
        // Reset on failure so a retry isn't permanently poisoned.
        scacsCache = null;
        throw err;
      });
  }
  return scacsCache;
}

/** Drops the in-memory cache. Mostly useful for tests. */
export function clearScacsCache(): void {
  scacsCache = null;
}
